module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3ea22ba000a74062474ac71ed11ae36f.png";